import { Component } from 'react';
import {
    FormControl,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';

class PlaceSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { value: "" };
    this.id = props.id;
  }

  handlePlaceSelect = (e) => {
    const value = e.target.value;

    // Update local state
    this.setState({ value });

    // Notify parent of the selection change
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  render() {
    const { numberOfPlayers } = this.props;

    return (
      <FormControl fullWidth>
        <Select
          labelId={`place-select-${this.id}`}
          id={`place-select-${this.id}`}
          value={this.state.value}
          displayEmpty
          variant="outlined"
          inputProps={{ MenuProps: { disableScrollLock: true } }}
          onChange={this.handlePlaceSelect}
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            backgroundColor: "white",
            height: "60px",
            textAlign: "center",
            textAlignLast: "center",
          }}
        >
          {/* Placeholder MenuItem */}
          <MenuItem value="" disabled>
            <Typography fontWeight="bold" color="gray">
              Place
            </Typography>
          </MenuItem>

          {/* List of places */}
          {[...Array(numberOfPlayers)]?.map((_, index) => (
            <MenuItem
              value={index + 1}
              key={`player-${this.id}-place-key-${index + 1}`}
            >
              <Typography>{index + 1}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

export default PlaceSelect;
